<template src="./EmpowermentSignIn.html"/>
<style lang="scss" scoped src="./EmpowermentSignIn.scss"/>

<script>

import {
  SfBreadcrumbs,
  SfNotification,
  SfHeading,
  SfIcon,
  SfButton
} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkLoader from "@/components/Ork/OrkLoader";
import {Client} from "@/models/client";
import UserAddress from "@/components/UserAddress";
import icons from "@/utils/icons";

export default {
  name: 'EmpowermentSignIn',
  transition: 'fade',
  components: {
    UserAddress,
    SfIcon,
    OrkLoader,
    SfHeading,
    SfNotification,
    SfBreadcrumbs,
    SfButton
  },
  data() {
    return {
      icons: icons,
      client: null,
      loading: false,
      error: null,
      breadcrumbs: [
        {
          text: this.$i18n.t('Home'),
          link: '/'
        },
        {
          text: this.$i18n.t('empowerment.breadcrumb'),
        }
      ]
    };
  },
  created() {
    sessionStorage.removeItem("configureEmpowerment")
    this.getEmpowermentAuth()
  },
  methods: {
    empowermentConnect() {
      const url = process.env.VUE_APP_HABILE_HTTP_VERSION + '://' + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + 'authorization.oauth2?client_id=' + process.env.VUE_APP_HABILE_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_HABILE_REDIRECT_URI + '&response_type=code&scope=openid email';
      window.location.href = url;
    },
    getEmpowermentAuth() {
      this.loading = true

      Api.account.loginEmpowerment(this.$router.history.current.query)
          .then((data) => {
            let parsedClient
            try {
              parsedClient = JSON.parse(data)
            } catch (e) {
              console.error(e)
              this.error = e;
            }
            try {
              this.client = Client.of(parsedClient)
            } catch (e) {
              this.error = e;
            }
          }).catch((e) => {
        console.error(e)
        this.error = e;
      }).finally(
          this.loading = false
      )
    }
  }
};
</script>
